<template>
  <div class="add-admin">
      <form class="addAdmin-form" @submit.prevent="registerButtonPressed">
      <ul class="addAdmin-form__fields">
        <h1> Add Admin </h1>
        <li>
          <label> Username </label> 
          <input type="text" placeholder="admin1" v-model="email" /> 
        </li>
        <li>
          <label> Password </label> 
          <input type="text" placeholder="24-07-1989" v-model="password" /> 
        </li>
        <button type="submit" >Register Admin</button>
      </ul>
    </form>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: 'AddAdmin',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    async registerButtonPressed() {
      try {
        var { user } = await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password);
          console.log(user)
        // signout
        firebase
          .auth()
          .signOut()
          
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>

<style lang="scss">
.addAdmin {
  
}

.addAdmin-form {
  display: flex;
  justify-content: center;
  
  //&__fields{ max-width: 320px;}
}



</style>
